export default class AppUtil {
  static rangeValidator = (
    value,
    id,
    items,
    minKey = "min_price",
    maxKey = "max_price"
  ) => {
    let isValidRange = true;
    for (const item of items) {
      const [min, max] = [parseFloat(item[minKey]), parseFloat(item[maxKey])];
      if (item.id !== id) {
        if (max) {
          if (value >= min && value <= max) {
            isValidRange = false;
            break;
          }
        } else {
          if (value >= min) {
            isValidRange = false;
            break;
          }
        }
      }
    }
    return isValidRange;
  };

  static getErrorMessage = (e) => {
    return e?.response?.data?.message
      ? e.response.data.message
      : e?.data?.data && typeof e?.data?.data === "string"
      ? e?.data?.data
      : e?.data?.msg ||
        e.message ||
        "An error occurred, please try again later.";
  };

  static getFormattedQuoteResult = (quoteResult) => {
    if (quoteResult?.common_details) {
      quoteResult.common_details.common_id =
        quoteResult.common_details?.id || null;
      quoteResult.common_details.quote_date =
        quoteResult.common_details?.created_at || null;
      quoteResult.common_details.services = quoteResult.common_details?.services
        ? quoteResult.common_details.services
            .split(",")
            .map((service) => service.trim())
        : [];
    }
    if (quoteResult?.inspection_details) {
      quoteResult.inspection_details.inspection_type = quoteResult
        .inspection_details?.inspection_type
        ? quoteResult.inspection_details?.inspection_type
            .split(",")
            .map((type) => type.trim())
        : [];
    }
    return quoteResult;
  };
}
